
const DEV = false
const urlLocalServer = "http://localhost:2000" //"https://mare-blog-server.fly.dev" // where the server is being run
const urlCloudServer = "https://blogapi.bughorse.com"
//END EDITABLE
const urlServer= DEV? urlLocalServer : urlCloudServer
export const GLOBALS = {
    urlServer,
    discord_outh_location : urlServer +  "/login/discord"
}